"use strict"
// let wlcApiUrl = "https://rivyo.com/wishlist/api/public/api";
let wlcApiUrl = "https://wishlist.thimatic-apps.com/api/public/api";
let wlcShop = Shopify.shop;
let wlcCustomer_id = (__st && __st.cid) || "";
let wlcPage = (__st && __st.p) || "";
let product_ids = [];
let th_wishlist = [];
let is_Wishlist_load = false;
let newTotalProduct = 0;
let backInStockSettings = null;
let wlBackInStockProduct = null;
const createSingleInstanceOfCSS = (assetURL) => {
    const instance = document.querySelector('link[href*="' + assetURL + '"]')
    if (instance === null) {
        const cssLink = document.createElement("link");
        cssLink.rel = "stylesheet";
        cssLink.media = "screen";
        cssLink.href = assetURL;
        document.getElementsByTagName('head')[0].appendChild(cssLink);
    }
}
createSingleInstanceOfCSS('https://wishlist.thimatic-apps.com/api/public/assets/js/wishliststyle.css')
const wlcCreateCookie = (name, value, days) => {
    let date = new Date();
    date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
    let expires = "; expires=" + date.toGMTString();
    document.cookie = name + "=" + value + expires + "; path=/";
}
const wlcGetCookie = (cname) => {
    let name = cname + "=";
    let ca = document.cookie.split(';');
    for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) == ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
        }
    }
    return "";
}
async function onDeleteWishListList($this_button) {
    let wishlistid = $this_button.getAttribute('data-wishlistid');
    let wishlist_dropdown_text = $this_button.getAttribute('data-wishlist_dropdown_text');
    let wlcIp = wlcGetCookie("wlcIp") || "";
    let data_json = JSON.stringify({ shop: wlcShop, wishlistid: wishlistid, ip: wlcIp, customer_id: wlcCustomer_id });
    const response = await fetch(wlcApiUrl + '/v1/removetab', {
        method: 'POST',
        body: data_json,
        headers: {
            'Content-Type': 'application/json'
        }
    });
    const myJson = await response.json();
    if (myJson.status === 200) {
        let wlcProd = [];
        let wlcProductVariant = {};
        document.querySelectorAll('.th_prd_wl_btn, .th_wl_col_btn, .th_wl_btn').forEach(function (val, idx) {
            let pId = val.getAttribute('data-product_id')
            let vId = val.getAttribute('data-variant_id');

            if (vId) {
                wlcProductVariant = {...wlcProductVariant, [vId] : pId}
            } else {
                wlcProd.push(pId);
            }

            if (idx === (document.querySelectorAll('.th_prd_wl_btn, .th_wl_col_btn, .th_wl_btn').length - 1)) {
                wlcProd = (product_ids || []).filter((x) => x);
            }
        });
        if(Object.keys(wlcProductVariant).length && !is_Wishlist_load){
            getWishlistSettings(wlcProductVariant, "1");
        } else if (wlcProd.length && !is_Wishlist_load) {
            product_ids = wlcProd;
            getWishlistSettings(wlcProd, "2");
        }
        pageloadWishlistgetEvent()
    }
}
const getWishlistSettings = async (product_ids, type) => {
    is_Wishlist_load = true;
    let wlcIp = wlcGetCookie("wlcIp") || "";
    let data_json = JSON.stringify({ shop: wlcShop, product_ids: product_ids, ip: wlcIp, customer_id: wlcCustomer_id });
    const response = await fetch(wlcApiUrl + '/v1/setting', {
        method: 'POST',
        body: data_json,
        headers: {
            'Content-Type': 'application/json'
        }
    });
    const myJson = await response.json();
    if (myJson.status === 200) {
        if (myJson.data.setting.app_enable === 1 && myJson.data.limit === true) {
            localStorage.setItem('th_wlc_pro_count', myJson.data.total)
            newTotalProduct = myJson.data.total;
            if (document.querySelector('.th_wlc_product_count')) {
                if (myJson.data.total > 0) {
                  document.querySelector('.th_wlc_product_count').style.display = 'inherit';
                } else {
                  if (document.querySelector('.th_wlc_product_count')) {
                    document.querySelector('.th_wlc_product_count').style.display = 'none';
                  }
                }
                document.querySelectorAll('.th_wlc_product_count').forEach(function (th_wlc_product_count, idx) {
                    th_wlc_product_count.innerHTML = '<span>' + myJson.data.total + '</span>';
                });
            }
            if (wlcIp === "") {
                wlcCreateCookie("wlcIp", myJson && myJson.data && myJson.data.ip ? myJson.data.ip : wlcIp, 1)
            }

            if(myJson.data.setting.icon){
                if(localStorage.getItem('th_wlc_icon') !== myJson.data.setting.icon){
                    localStorage.setItem('th_wlc_icon', myJson.data.setting.icon)
                }
            } else{
                localStorage.removeItem("th_wlc_icon")
            }

            th_wishlist = myJson.data.wishlist;
            addWishlistButton(myJson.data.setting, myJson.data.products, myJson.data.total, type)
            is_Wishlist_load = false;
        }
    }
}
function addWishlistButton(data, products, totalProduct, type) {
    let isModalOpen = false;
    let button_position = "left";
    let button_position_full = "inline-flex";
    let button_position_width_full = "auto";
    let button_background = "transparent";
    let button_border_color = "transparent";
    let button_border_width = "0";
    let button_background_after = "transparent";
    let button_border_color_after = "transparent";
    let button_color_before = "#000000";
    let button_color_after = "#ff0000";
    let button_border_radius = "0";
    let button_border_type = "solid";
    let button_top_bottom_padding = "0";
    let button_left_right_padding = "0";
    let buttonDef_position = "left";
    let buttonDef_position_full = "inline-flex";
    let buttonDef_position_width_full = "auto";
    let buttonDef_background = "transparent";
    let buttonDef_border_color = "transparent";
    let buttonDef_border_width = "0";
    let buttonDef_background_after = "transparent";
    let buttonDef_border_color_after = "transparent";
    let buttonDef_color_before = "#000000";
    let buttonDef_color_after = "#ff0000";
    let buttonDef_border_radius = "0";
    let buttonDef_border_type = "solid";
    let buttonDef_top_bottom_padding = "0";
    let buttonDef_left_right_padding = "0";
    let buttonCol_position = "left";
    let buttonCol_position_full = "inline-flex";
    let buttonCol_position_width_full = "auto";
    let buttonCol_background = "transparent";
    let buttonCol_border_color = "transparent";
    let buttonCol_border_width = "0";
    let buttonCol_background_after = "transparent";
    let buttonCol_border_color_after = "transparent";
    let buttonCol_color_before = "#000000";
    let buttonCol_color_after = "#ff0000";
    let buttonCol_border_radius = "0";
    let buttonCol_border_type = "solid";
    let buttonCol_top_bottom_padding = "0";
    let buttonCol_left_right_padding = "0";
    if (wlcPage === "product") {
        buttonDef_position = data.button_position === "1" ? "left" : data.button_position === "2" ? "right" : data.button_position === "3" ? "center" : "inherit";
        buttonDef_position_full = data.button_position === "4" ? "flex" : "inline-flex";
        buttonDef_position_width_full = data.button_position === "4" ? "100%" : "auto";
        buttonDef_background = data.button_type === "3" ? data.button_bg_color_before : "transparent";
        buttonDef_border_color = data.button_type === "3" ? data.button_border_color_before : "transparent";
        buttonDef_border_width = data.button_type === "3" ? data.button_border_width : "0";
        buttonDef_background_after = data.button_type === "3" ? data.button_bg_color_after : "transparent";
        buttonDef_border_color_after = data.button_type === "3" ? data.button_border_color_after : "transparent";
        buttonDef_color_before = data.button_color_before;
        buttonDef_border_radius = data.button_border_radius;
        buttonDef_border_type = data.button_border_type;
        buttonDef_top_bottom_padding = data.button_top_bottom_padding;
        buttonDef_left_right_padding = data.button_left_right_padding;
        buttonDef_color_after = data.button_color_after;
    } else {
        buttonDef_position = data.product_collection_button_position === "1" ? "left" : data.product_collection_button_position === "2" ? "right" : data.product_collection_button_position === "3" ? "center" : "inherit";
        buttonDef_position_full = data.product_collection_button_position === "4" ? "flex" : "inline-flex";
        buttonDef_position_width_full = data.product_collection_button_position === "4" ? "100%" : "auto";
        buttonDef_background = (data.product_collection_button_type === "3") ? data.product_collection_button_bg_color_before : "transparent";
        buttonDef_border_color = (data.product_collection_button_type === "3") ? data.product_collection_button_border_color_before : "transparent";
        buttonDef_border_width = (data.product_collection_button_type === "3") ? data.product_collection_button_border_width : "0";
        buttonDef_background_after = (data.product_collection_button_type === "3") ? data.product_collection_button_bg_color_after : "transparent";
        buttonDef_border_color_after = (data.product_collection_button_type === "3") ? data.product_collection_button_border_color_after : "transparent";
        buttonDef_color_before = data.product_collection_button_color_before;
        buttonDef_border_radius = data.product_collection_button_border_radius;
        buttonDef_border_type = data.button_border_type;
        buttonDef_top_bottom_padding = data.product_collection_button_top_bottom_padding;
        buttonDef_left_right_padding = data.product_collection_button_left_right_padding;
        buttonDef_color_after = data.product_collection_button_color_after;
    }
    button_position = data.button_position === "1" ? "left" : data.button_position === "2" ? "right" : data.button_position === "3" ? "center" : "inherit";
    button_position_full = data.button_position === "4" ? "flex" : "inline-flex";
    button_position_width_full = data.button_position === "4" ? "100%" : "auto";
    button_background = data.button_type === "3" ? data.button_bg_color_before : "transparent";
    button_border_color = data.button_type === "3" ? data.button_border_color_before : "transparent";
    button_border_width = data.button_type === "3" ? data.button_border_width : "0";
    button_background_after = data.button_type === "3" ? data.button_bg_color_after : "transparent";
    button_border_color_after = data.button_type === "3" ? data.button_border_color_after : "transparent";
    button_color_before = data.button_color_before;
    button_border_radius = data.button_border_radius;
    button_border_type = data.button_border_type;
    button_top_bottom_padding = data.button_top_bottom_padding;
    button_left_right_padding = data.button_left_right_padding;
    button_color_after = data.button_color_after;
    buttonCol_position = data.product_collection_button_position === "1" ? "left" : data.product_collection_button_position === "2" ? "right" : data.product_collection_button_position === "3" ? "center" : "inherit";
    buttonCol_position_full = data.product_collection_button_position === "4" ? "flex" : "inline-flex";
    buttonCol_position_width_full = data.product_collection_button_position === "4" ? "100%" : "auto";
    buttonCol_background = (data.product_collection_button_type === "3") ? data.product_collection_button_bg_color_before : "transparent";
    buttonCol_border_color = (data.product_collection_button_type === "3") ? data.product_collection_button_border_color_before : "transparent";
    buttonCol_border_width = (data.product_collection_button_type === "3") ? data.product_collection_button_border_width : "0";
    buttonCol_background_after = (data.product_collection_button_type === "3") ? data.product_collection_button_bg_color_after : "transparent";
    buttonCol_border_color_after = (data.product_collection_button_type === "3") ? data.product_collection_button_border_color_after : "transparent";
    buttonCol_color_before = data.product_collection_button_color_before;
    buttonCol_border_radius = data.product_collection_button_border_radius;
    buttonCol_border_type = data.button_border_type;
    buttonCol_top_bottom_padding = data.product_collection_button_top_bottom_padding;
    buttonCol_left_right_padding = data.product_collection_button_left_right_padding;
    buttonCol_color_after = data.product_collection_button_color_after;
    let displaymodal = isModalOpen ? "block" : "none";
    let cssdata = '.th_wl_btn{z-index:2; position: relative; display: flex; justify-content: ' + buttonDef_position + ';} ' +
        '.th_prd_wl_btn{z-index:2; position: relative; display: flex; justify-content: ' + button_position + ';} ' +
        '.th_wl_col_btn{z-index:2; position: relative; display: flex; justify-content: ' + buttonCol_position + ';} ' +
        '.th_wl_btn .th_wl_button{width:' + buttonDef_position_width_full + '; justify-content: center;cursor: pointer; font-size:16px; display: ' + buttonDef_position_full + '; flex-wrap: wrap; align-items: center; color: ' + buttonDef_color_before + '; background:' + buttonDef_background + ';border-color:' + buttonDef_border_color + '; border-width:' + buttonDef_border_width + 'px; border-radius: ' + buttonDef_border_radius + 'px;border-style:' + buttonDef_border_type + '; padding: ' + buttonDef_top_bottom_padding + 'px ' + buttonDef_left_right_padding + 'px;}' +  
        '.th_prd_wl_btn .th_wl_button{width:' + button_position_width_full + '; justify-content: center;cursor: pointer; font-size:16px; display: ' + button_position_full + '; flex-wrap: wrap; align-items: center; color: ' + button_color_before + '; background:' + button_background + ';border-color:' + button_border_color + '; border-width:' + button_border_width + 'px; border-radius: ' + button_border_radius + 'px;border-style:' + button_border_type + '; padding: ' + button_top_bottom_padding + 'px ' + button_left_right_padding + 'px;}' +
        '.th_wl_col_btn .th_wl_button{width:' + buttonCol_position_width_full + '; justify-content: center;cursor: pointer; font-size:16px; display: ' + buttonCol_position_full + '; flex-wrap: wrap; align-items: center; color: ' + buttonCol_color_before + '; background:' + buttonCol_background + ';border-color:' + buttonCol_border_color + '; border-width:' + buttonCol_border_width + 'px; border-radius: ' + buttonCol_border_radius + 'px;border-style:' + buttonCol_border_type + '; padding: ' + buttonCol_top_bottom_padding + 'px ' + buttonCol_left_right_padding + 'px;}' +
        '.th_wl_btn .th_wl_button_after{width:' + buttonDef_position_width_full + '; justify-content: center;cursor: pointer; font-size:16px; display: ' + buttonDef_position_full + '; flex-wrap: wrap; align-items: center; color: ' + buttonDef_color_after + '; background:' + buttonDef_background_after + ';border-color:' + buttonDef_border_color_after + '; border-width:' + buttonDef_border_width + 'px; border-radius: ' + buttonDef_border_radius + 'px;border-style:' + buttonDef_border_type + '; padding: ' + buttonDef_top_bottom_padding + 'px ' + buttonDef_left_right_padding + 'px;}' +  
        '.th_prd_wl_btn .th_wl_button_after{width:' + button_position_width_full + '; justify-content: center;cursor: pointer; font-size:16px; display: ' + button_position_full + '; flex-wrap: wrap; align-items: center; color: ' + button_color_after + '; background:' + button_background_after + ';border-color:' + button_border_color_after + '; border-width:' + button_border_width + 'px; border-radius: ' + button_border_radius + 'px;border-style:' + button_border_type + '; padding: ' + button_top_bottom_padding + 'px ' + button_left_right_padding + 'px;}' +
        '.th_wl_col_btn .th_wl_button_after{width:' + buttonCol_position_width_full + '; justify-content: center;cursor: pointer; font-size:16px; display: ' + buttonCol_position_full + '; flex-wrap: wrap; align-items: center; color: ' + buttonCol_color_after + '; background:' + buttonCol_background_after + ';border-color:' + buttonCol_border_color_after + '; border-width:' + buttonCol_border_width + 'px; border-radius: ' + buttonCol_border_radius + 'px;border-style:' + buttonCol_border_type + '; padding: ' + buttonCol_top_bottom_padding + 'px ' + buttonCol_left_right_padding + 'px;}' +
        '.th_wl_button .th_wl_icon, .th_wl_button_after .th_wl_icon{margin-right:6px; width: 16px; height: 16px;}' +
        '.th_wl_modal {align-items: center; justify-content: center; background: #00000047;overflow-x: hidden; overflow-y: auto; z-index: 99999;position: fixed;top: 0;right: 0;bottom: 0;left: 0;display:none}' +
        '.th_wl_fade{opacity: 1;}' +
        '.th_wl_modal-dialog{flex: 0 0 500px; max-width: 500px;margin: 1.75rem auto; position: relative;width: auto;pointer-events: none;webkit-transform: translate(0,0);transform: translate(0,0);transition: -webkit-transform .3s ease-out;transition: transform .3s ease-out;transition: transform .3s ease-out,-webkit-transform .3s ease-out;-webkit-transform: translate(0,-25%);transform: translate(0,-25%);}' +
        '.th_wl_modal_content{position: relative;display: -webkit-box;display: -ms-flexbox;display: flex;-webkit-box-orient: vertical;-webkit-box-direction: normal;-ms-flex-direction: column;flex-direction: column;width: 100%;pointer-events: auto;background-color: #fff;background-clip: padding-box;border: 1px solid rgba(0,0,0,.2);border-radius: 0.3rem;outline: 0;}' +
        '.th_wl_modal_header{display: flex;-webkit-box-align: start; align-items: center;-webkit-box-pack: justify;justify-content: space-between;padding: 16px;border-bottom: 1px solid #e9ecef;border-top-left-radius: 0.3rem;border-top-right-radius: 0.3rem;}' +
        '.th_wl_modal_title{margin-bottom: 0; line-height: 1.5;font-size: 20px;font-weight: 600;margin:0}' +
        '.th_wl_modal_close{cursor:pointer; padding: 16px;margin: -16px -16px -16px auto;background-color: transparent; border: 0;float: right;font-size: 20px;font-weight: 700;line-height: 1;color: #000;text-shadow: 0 1px 0 #fff;opacity: .5;}' +
        '.th_wl_modal_body{padding: 16px}' +
        '.th_wl_lbl{display: inline-block;margin-bottom: 5px;font-size: 15px; font-weight: 600;}' +
        '.th_wl_form_control{display: block;width: 100%;padding: 6px 12px;font-size: 15px;line-height: 1.5;color: #495057;background-color: #fff;background-clip: padding-box; border: 1px solid #ced4da; border-radius: 4px; transition: border-color .15s ease-in-out,box-shadow .15s ease-in-out;}' +
        '.th_wl_form_control:focus {color: #495057;background-color: #fff;border-color: #ced4da; outline: 0;box-shadow:unset;}' +
        '.th_wl_form_text{color: #6c757d;display: block;margin-top: 4px;font-size: 80%;font-weight: 400;}' +
        '.th_wl_modal_footer{display: -webkit-box;display: -ms-flexbox;display: flex;-webkit-box-align: center;-ms-flex-align: center;align-items: center;-webkit-box-pack: end;-ms-flex-pack: end;justify-content: flex-end;padding: 1rem;border-top: 1px solid #e9ecef;}' +
        '.th_prd_wl_btn, .th_wl_col_btn, .th_wl_btn, .th_wl_btn_modal{display: inline-block; font-weight: 400; text-align: center; white-space: nowrap; vertical-align: middle; -webkit-user-select: none; -moz-user-select: none; -ms-user-select: none; user-select: none; border: 1px solid transparent; padding: 0.375rem 0.75rem; font-size: 15px; line-height: 1.5; border-radius: 0.25rem; transition: color .15s ease-in-out,background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out;}' +
        '.th_wl_btn-secondary{margin-right: 10px; color: ' + data.wishlist_model_cancel_button_text_colour + '; background-color: ' + data.wishlist_model_cancel_button_bg_colour + '; border-color: ' + data.wishlist_model_cancel_button_bg_colour + '; cursor: pointer;}' +
        '.th_wl_btn-primary{color: ' + data.wishlist_model_create_button_text_colour + '; background-color: ' + data.wishlist_model_create_button_bg_colour + '; border-color: ' + data.wishlist_model_create_button_bg_colour + '; cursor: pointer; position: relative; }' +
        '.wl_btn_loading{position: absolute; width: 100%; height: 100%; left: 0;top: 0;display: flex; align-items: center;justify-content: center; flex-wrap: wrap; z-index: 2; background-color: ' + data.wishlist_model_create_button_bg_colour + ';}' +
        '.th_wl_btn-primary .wl_btn_loading svg path{fill: ' + data.wishlist_model_create_button_text_colour + ';}' +
        '.th_wl_btn-primary .wl_btn_loading svg {width: 35px; height: 35px;}'+
        '.th_wl_btn .th_wl_dropbtn{height: 100%;justify-content: center;cursor: pointer; font-size:16px; display: ' + buttonDef_position_full + '; flex-wrap: wrap; align-items: center; color: ' + buttonDef_color_before + '; background:' + buttonDef_background + ';border-color:' + buttonDef_border_color + '; border-width:' + buttonDef_border_width + 'px; border-radius: ' + buttonDef_border_radius + 'px;border-style:' + buttonDef_border_type + '; padding: ' + buttonDef_top_bottom_padding + 'px ' + buttonDef_left_right_padding + 'px;border-left: 0;}' +
        '.th_prd_wl_btn .th_wl_dropbtn{height: 100%;justify-content: center;cursor: pointer; font-size:16px; display: ' + button_position_full + '; flex-wrap: wrap; align-items: center; color: ' + button_color_before + '; background:' + button_background + ';border-color:' + button_border_color + '; border-width:' + button_border_width + 'px; border-radius: ' + button_border_radius + 'px;border-style:' + button_border_type + '; padding: ' + button_top_bottom_padding + 'px ' + button_left_right_padding + 'px;border-left: 0;}' +
        '.th_wl_col_btn .th_wl_dropbtn{height: 100%;justify-content: center;cursor: pointer; font-size:16px; display: ' + buttonCol_position_full + '; flex-wrap: wrap; align-items: center; color: ' + buttonCol_color_before + '; background:' + buttonCol_background + ';border-color:' + buttonCol_border_color + '; border-width:' + buttonCol_border_width + 'px; border-radius: ' + buttonCol_border_radius + 'px;border-style:' + buttonCol_border_type + '; padding: ' + buttonCol_top_bottom_padding + 'px ' + buttonCol_left_right_padding + 'px;border-left: 0;}' +
        '.th_wl_dropdown{position: relative;display: inline-block;}' +
        '.th_wl_dropdown_content{right: 0; border: 1px solid #c7c7c7; border-top: 0;display: none;position: absolute;background-color: #fff;min-width: 160px; overflow: auto;z-index: 1; margin: 0;padding: 0;list-style: none;}' +
        'ul.th_wl_dropdown_content li{display: flex; justify-content: space-between; cursor:pointer; color: black;padding:0;text-decoration: none;text-align: start; font-size: 14px;}' +
        'ul.th_wl_dropdown_content li span.th_wl_dropdown_option{flex:0 0 calc(100% - 24px);padding:4px 10px;}' +
        'ul.th_wl_dropdown_content li span.th_wl_dropdown_option_delete_btn{border-left:1px solid transparent;flex:0 0 24px;display: flex;align-items: center;justify-content: center;  }' +
        'ul.th_wl_dropdown_content li span.th_wl_dropdown_option_delete_btn svg{width:14px;height:14px;}' +
        'ul.th_wl_dropdown_content li:hover{background: #e9e9e9;}' +
        'ul.th_wl_dropdown_content li:hover span.th_wl_dropdown_option_delete_btn{border-color:#c7c7c7}' +
        'ul.th_wl_dropdown_content li span.th_wl_dropdown_option_delete_btn:hover{background:#c7c7c7}' +
        '.th_wl_dropdown_option_delete_btn{cursor: pointer;}' +
        '.d-flex{display: flex}' +
        '.th_wl_button svg, .th_wl_button_after svg{width:16px; height:16px}' +
        '.th_wl_btn .th_wl_button svg, .th_wl_btn .th_wl_button svg path{fill:' + buttonDef_color_before + '}' +
        '.th_prd_wl_btn .th_wl_button svg, .th_prd_wl_btn .th_wl_button svg path{fill:' + button_color_before + '}' +
        '.th_wl_col_btn .th_wl_button svg, .th_wl_col_btn .th_wl_button svg path{fill:' + buttonCol_color_before + '}' +
        '.th_wl_btn .th_wl_button_after svg, .th_wl_btn .th_wl_button_after svg path{fill:' + buttonDef_color_after + '}' +
        '.th_prd_wl_btn .th_wl_button_after svg, .th_prd_wl_btn .th_wl_button_after svg path{fill:' + button_color_after + '}' +
        '.th_wl_col_btn .th_wl_button_after svg, .th_wl_col_btn .th_wl_button_after svg path{fill:' + buttonCol_color_after + '}' +
        '#th-wl-sucess-mgs,#th-wl-error-mgs {font-size: 17px;min-width: 250px;padding: 10px 12px;text-align: left;border-radius: 2px;position: fixed;right: 0;top: 0;z-index: 99999;-webkit-animation-name: fadeInRight;animation-name: fadeInRight;-webkit-animation-delay: 50ms;-moz-animation-delay: 50ms;animation-delay: 50ms;-webkit-animation-duration: 300ms;animation-duration: 300ms;-webkit-animation-fill-mode: both;animation-fill-mode: both;}' +
        '#th-wl-sucess-mgs {color: ' + data.success_message_text_color + ';background-color: ' + data.success_message_bg_color + ';}' +
        '#th-wl-error-mgs {color: ' + data.error_message_text_color + ';background-color: ' + data.error_message_bg_color + ';}' +
        '@-webkit-keyframes fadeInRight {from { opacity: 0; -webkit-transform: translate3d(100%, 0, 0); transform: translate3d(100%, 0, 0);}to { opacity: 1;  -webkit-transform: none; transform: none;}}' +
        '@keyframes fadeInRight {from { opacity: 0; -webkit-transform: translate3d(100%, 0, 0); transform: translate3d(100%, 0, 0);  }to { opacity: 1;  -webkit-transform: none;  transform: none;  }}' +
        '@media (max-width: 575px) {.th_wl_modal-dialog{flex: 0 0 calc(100% - 30px); max-width: calc(100% - 30px);}}' +
        '#loading-spinner {animation: loading-spinner 1s linear infinite}' +
        '@keyframes loading-spinner{from{transform: rotate(0deg);} to {transform: rotate(360deg);}}';
    var wc_head = document.head || document.getElementsByTagName('head')[0],
        style = document.createElement('style');
    wc_head.appendChild(style);
    style.type = 'text/css';
    style.id = 'wc_stylesheet_tag_wishlist'
    if (style.styleSheet) {
        style.styleSheet.cssText = cssdata;
    } else {
        style.appendChild(document.createTextNode(cssdata)); 
    }
    if (document.querySelector('.th_wlc_product_count')) {
      if (newTotalProduct > 0) {
        document.querySelector('.th_wlc_product_count').style.display = 'inherit';
      } else {
        if (document.querySelector('.th_wlc_product_count')) {
          document.querySelector('.th_wlc_product_count').style.display = 'none';
        }
      }
        document.querySelectorAll('.th_wlc_product_count').forEach(function (th_wlc_product_count, idx) {
            th_wlc_product_count.innerHTML = '<span>' + newTotalProduct + '</span>';
        });
        //document.querySelector('.th_wlc_product_count').innerHTML = '<span>' + newTotalProduct + '</span>'
    }

    let iconBefor = data?.icon ? data.icon : '<svg class="th_wl_icon" width="16px" height="16px" viewBox="0 0 26 23" fill=' + button_color_before + '><path d="M24.8759 3.27339C24.1475 2.06525 23.0806 1.12141 21.8207 0.57048C20.3932 -0.0562504 18.7897 -0.169062 17.1839 0.245058C15.7124 0.624602 14.279 1.4478 13 2.64198C11.7209 1.44769 10.2874 0.624442 8.8156 0.244952C7.20974 -0.169327 5.60622 -0.0564097 4.17865 0.570745C2.91872 1.12185 1.8519 2.06588 1.12359 3.27418C0.360858 4.53529 -0.0271625 6.06892 0.00147825 7.70909C0.128635 15.0007 10.5135 21.6311 12.594 22.8863C12.7175 22.9608 12.8575 23 13 23C13.1425 23 13.2825 22.9608 13.406 22.8863C15.4867 21.6309 25.8725 14.9993 25.9986 7.70782C26.0269 6.06775 25.6387 4.53428 24.8759 3.27339V3.27339ZM24.3739 7.67728C24.3332 10.0348 22.8306 12.7835 20.0288 15.6259C17.4342 18.258 14.4828 20.242 13 21.1651C11.5172 20.2422 8.56627 18.2584 5.97185 15.6262C3.16993 12.784 1.66731 10.0356 1.62618 7.67808C1.58129 5.10386 2.77074 3.03273 4.80794 2.13773C5.4756 1.84606 6.19237 1.69728 6.91592 1.70019C8.78442 1.70019 10.7609 2.64623 12.4206 4.41138C12.4962 4.49179 12.5864 4.55566 12.6859 4.59926C12.7853 4.64285 12.8921 4.6653 12.9999 4.6653C13.1078 4.6653 13.2145 4.64285 13.314 4.59926C13.4134 4.55566 13.5036 4.49179 13.5792 4.41138C15.885 1.95916 18.8021 1.08796 21.1913 2.13757C23.2287 3.03225 24.4183 5.10307 24.3739 7.67712V7.67728Z" fill=' + button_color_before + '/></svg>';
    let iconAfter = data?.icon ? data.icon : '<svg class="th_wl_icon" version="1.1" id="Layer_1" x="0px" y="0px" fill=' + button_color_after + ' width="16px" height="16px" viewBox="0 0 26 23" ><path d="M25.3,7.9c-0.1,6.9-9.9,13.2-11.9,14.4c-0.1,0.1-0.2,0.1-0.4,0.1c-0.1,0-0.3,0-0.4-0.1c-2-1.2-11.8-7.5-11.9-14.3 c0-1.6,0.3-3,1.1-4.2c0.7-1.1,1.7-2,2.9-2.6C6,0.6,7.5,0.5,9,0.9c1.4,0.4,2.8,1.1,4,2.3c1.2-1.1,2.6-1.9,4-2.3 c1.5-0.4,3-0.3,4.4,0.3c1.2,0.5,2.2,1.4,2.9,2.6C24.9,4.9,25.3,6.4,25.3,7.9z"/></svg>';
    let deleteIcon = '<svg  viewBox="0 0 24 24"><path d="m21 5h-18a1 1 0 0 0 0 2h2v12a2.9991 2.9991 0 0 0 3 3h8a2.9989 2.9989 0 0 0 3-3v-12h2a1 1 0 0 0 0-2zm-4 14a1.0014 1.0014 0 0 1 -1 1h-8a1.0014 1.0014 0 0 1 -1-1v-12h10z"/><path d="m10 4h4a1 1 0 0 0 0-2h-4a1 1 0 0 0 0 2z"/><path d="m11 16v-5a1 1 0 0 0 -2 0v5a1 1 0 0 0 2 0z"/><path d="m15 16v-5a1 1 0 0 0 -2 0v5a1 1 0 0 0 2 0z"/></svg>'

    if(document.querySelector(".th_wlc_position_relative")){
        if(data?.icon){
            document.querySelectorAll('.th_wlc_position_relative').forEach(function (th_wlc_icon, idx) {
              if (th_wlc_icon.querySelector("svg")) {
               th_wlc_icon.querySelector("svg").remove(); 
              }
                let newWlIcon = "";
                newWlIcon += th_wlc_icon.innerHTML;
                newWlIcon += data?.icon ? data.icon : '<svg width="26" height="23" viewBox="0 0 26 23" fill="none"><path d="M24.8759 3.27339C24.1475 2.06525 23.0806 1.12141 21.8207 0.57048C20.3932 -0.0562504 18.7897 -0.169062 17.1839 0.245058C15.7124 0.624602 14.279 1.4478 13 2.64198C11.7209 1.44769 10.2874 0.624442 8.8156 0.244952C7.20974 -0.169327 5.60622 -0.0564097 4.17865 0.570745C2.91872 1.12185 1.8519 2.06588 1.12359 3.27418C0.360858 4.53529 -0.0271625 6.06892 0.00147825 7.70909C0.128635 15.0007 10.5135 21.6311 12.594 22.8863C12.7175 22.9608 12.8575 23 13 23C13.1425 23 13.2825 22.9608 13.406 22.8863C15.4867 21.6309 25.8725 14.9993 25.9986 7.70782C26.0269 6.06775 25.6387 4.53428 24.8759 3.27339V3.27339ZM24.3739 7.67728C24.3332 10.0348 22.8306 12.7835 20.0288 15.6259C17.4342 18.258 14.4828 20.242 13 21.1651C11.5172 20.2422 8.56627 18.2584 5.97185 15.6262C3.16993 12.784 1.66731 10.0356 1.62618 7.67808C1.58129 5.10386 2.77074 3.03273 4.80794 2.13773C5.4756 1.84606 6.19237 1.69728 6.91592 1.70019C8.78442 1.70019 10.7609 2.64623 12.4206 4.41138C12.4962 4.49179 12.5864 4.55566 12.6859 4.59926C12.7853 4.64285 12.8921 4.6653 12.9999 4.6653C13.1078 4.6653 13.2145 4.64285 13.314 4.59926C13.4134 4.55566 13.5036 4.49179 13.5792 4.41138C15.885 1.95916 18.8021 1.08796 21.1913 2.13757C23.2287 3.03225 24.4183 5.10307 24.3739 7.67712V7.67728Z" fill="black"></path></svg>';
                th_wlc_icon.innerHTML = newWlIcon
            });
        }
    }
    let wishlistDropdown = '';
    wishlistDropdown += '<div class="th_wl_dropdown">'
    wishlistDropdown += '<button type="button" class="th_wl_dropbtn"><svg width="20px" height="20px" viewBox="0 0 20 20"><path fill="#5C5F62" d="M13.098 8H6.902c-.751 0-1.172.754-.708 1.268L9.292 12.7c.36.399 1.055.399 1.416 0l3.098-3.433C14.27 8.754 13.849 8 13.098 8Z"/></svg></button>'
    wishlistDropdown += '<ul class="th_wl_dropdown_content">'
    th_wishlist.forEach((x) => {
        wishlistDropdown += '<li><span class="th_wl_dropdown_option" data-wishlistid="' + x.id + '" data-wishlist_dropdown_text="' + data.wishlist_dropdown_text + '">' + x.name + '</span><span class="th_wl_dropdown_option_delete_btn" data-wishlistid="' + x.id + '" data-wishlist_dropdown_text="' + data.wishlist_dropdown_text + '" onclick="onDeleteWishListList(this)">' + deleteIcon + '</span></li>';
    });
    wishlistDropdown += '<li><span class="th_wl_dropdown_option">' + data.wishlist_dropdown_text + '</span></li>';
    wishlistDropdown += '</ul>'
    wishlistDropdown += '</div>'
    let createNewWishlist = '';
    createNewWishlist += '<div class="th_wl_modal th_wl_fade" id="createNewWishlist">';
    createNewWishlist += '<div class="th_wl_modal-dialog th_wl_modal-dialog-centered">'
    createNewWishlist += '<div class="th_wl_modal_content">'

    createNewWishlist += '<div class="th_wl_modal_header">'
    createNewWishlist += '<h5 class="th_wl_modal_title">' + data.wishlist_model_title + '</h5>'
    createNewWishlist += '<button type="button" class="th_wl_modal_close th_wl_modal_close_coman" ><span aria-hidden="true">×</span></button>'
    createNewWishlist += '</div>';

    createNewWishlist += '<div class="th_wl_modal_body">'
    createNewWishlist += '<label class="th_wl_lbl" for="wishlistlisttext">' + data.wishlist_model_label + '</label>'
    createNewWishlist += '<input type="text" class="th_wl_form_control" id="wishlistlisttext" placeholder="' + data.wishlist_model_placeholder + '">'
    createNewWishlist += '<small id="emailHelp" class="th_wl_form_text">' + data.wishlist_model_description + '</small>'
    createNewWishlist += '</div>';

    createNewWishlist += '<div class="th_wl_modal_footer">'
    createNewWishlist += '<button type="button" class="th_wl_btn_modal th_wl_btn-secondary th_wl_modal_close_coman" data-dismiss="modal">' + data.wishlist_model_cancel_button + '</button>'
    createNewWishlist += '<button type="button" class="th_wl_btn_modal th_wl_btn-primary" disabled >' + data.wishlist_model_create_button + '</button>'
    createNewWishlist += '</div>';

    createNewWishlist += '</div>';
    createNewWishlist += '</div>';
    createNewWishlist += '</div>';
    let wishlistDropdownDisplay = '';
    if (data.multiple_wishlist === 1) {
        wishlistDropdownDisplay += wishlistDropdown
    }
    const wishlistButton = ($this_button, record) => {
      let button_text_before = "Add to Wishlist";
      let button_type = "1";
      let total_count = "0";
      if (record) {
       if ($this_button.classList.contains('th_wl_col_btn')) {
          button_text_before = data.product_collection_button_text_before;
            button_type = data.product_collection_button_type;
            total_count = data.product_collection_total_count;
        }
        else if ($this_button.classList.contains('th_prd_wl_btn')) {
          button_text_before = data.button_text_before;
            button_type = data.button_type;
            total_count = data.total_count;
        }
        else if (wlcPage === "product") {
            button_text_before = data.button_text_before;
            button_type = data.button_type;
            total_count = data.total_count;
        } else {
            button_text_before = data.product_collection_button_text_before;
            button_type = data.product_collection_button_type;
            total_count = data.product_collection_total_count;
        } 
      } 
      else {
        if (wlcPage === "product") {
            button_text_before = data.button_text_before;
            button_type = data.button_type;
            total_count = data.total_count;
        } else {
            button_text_before = data.product_collection_button_text_before;
            button_type = data.product_collection_button_type;
            total_count = data.product_collection_total_count;
        } 
      }
      var coasd = record?.wishlistCount ? record.wishlistCount : 0;
        let count = '<span class="th_wl_count" style="margin-left: 5px">(' + coasd + ')</span>'
        let text_icon_bg = '<div class="th_wl_button">'
        let icon = '<div class="th_wl_button">';
        if (coasd > 0 && total_count == 1) {
            text_icon_bg += iconBefor + '<span class="th_wl_text">' + button_text_before + '</span>' + count;
            text_icon_bg += '</div>';
            icon += iconBefor + count;
            icon += '</div>';
        } else {
            text_icon_bg += iconBefor + '<span class="th_wl_text">' + button_text_before + '</span>';
            text_icon_bg += '</div>';
            icon += iconBefor;
            icon += '</div>';
        }
        let wishlistbtn = '<div class="d-flex">'
        if (button_type === "3") {
            wishlistbtn += text_icon_bg + wishlistDropdownDisplay;
        } else if (button_type === "1") {
            wishlistbtn += icon + wishlistDropdownDisplay;
        }
        wishlistbtn += '</div>';
        return wishlistbtn
    }
    const createNewListNameValueChange = () => {
      if (document.querySelector('#createNewWishlist')) {
        var elemnt = document.querySelector('#createNewWishlist #wishlistlisttext');
        elemnt.addEventListener('keyup', function(value){
            var results = elemnt.value;
            if (results == '') {
              document.querySelector('#createNewWishlist [data-product_id]').setAttribute('disabled', 'disabled');   
            }
            else {
              document.querySelector('#createNewWishlist [data-product_id]').removeAttribute('disabled', 'disabled');
            }
        }); 
      }
    }
    const wishlistButtonAfter = ($this_button, record) => {
      let button_text_after = "Added to Wishlist";
      let button_type = "1";
      let total_count = "0";
      if (record) {
        if ($this_button.classList.contains('th_wl_col_btn')) {
         button_text_after = data.product_collection_button_text_after;
            button_type = data.product_collection_button_type;
            total_count = data.product_collection_total_count;
        }
        else if ($this_button.classList.contains('th_prd_wl_btn')) {
            button_text_after = data.button_text_after;
            button_type = data.button_type;
            total_count = data.total_count;
        }
        else if (wlcPage === "product") {
            button_text_after = data.button_text_after;
            button_type = data.button_type;
            total_count = data.total_count;
        } else {
            button_text_after = data.product_collection_button_text_after;
            button_type = data.product_collection_button_type;
            total_count = data.product_collection_total_count;
        }
      }
      else {
        if (wlcPage === "product") {
            button_text_after = data.button_text_after;
            button_type = data.button_type;
            total_count = data.total_count;
        } else {
            button_text_after = data.product_collection_button_text_after;
            button_type = data.product_collection_button_type;
            total_count = data.product_collection_total_count;
        }
      }
        var coasd = record?.wishlistCount ? record.wishlistCount : 0;
        let count = '<span class="th_wl_count" style="margin-left: 5px">(' + coasd + ')</span>';
        let text_icon_bg_after = '<div class="th_wl_button_after">';
        let icon_after = '<div class="th_wl_button_after">';
        if (coasd > 0 && total_count == 1) {
            text_icon_bg_after += iconAfter + '<span class="th_wl_text">' + button_text_after + '</span>' + count;
            text_icon_bg_after += '</div>';
            icon_after += iconAfter + count;
            icon_after += '</div>';
        } else {
            text_icon_bg_after += iconAfter + '<span class="th_wl_text">' + button_text_after + '</span>';
            text_icon_bg_after += '</div>';
            icon_after += iconAfter;
            icon_after += '</div>';
        }
        let wishlistAfter = '<div class="d-flex">';
        if (button_type === "3") {
            wishlistAfter += text_icon_bg_after;
        } else if (button_type === "1") {
            wishlistAfter += icon_after;
        }
        wishlistAfter += '</div>';
        return wishlistAfter;
    }
    const sucessMessage = (message) => {
      if (typeof $th_wishlistAdd_callback_successMessage == 'function') {
        $th_wishlistAdd_callback_successMessage(message);
      } else {
        document.querySelector('body').insertAdjacentHTML('beforeend', '<div id="th-wl-sucess-mgs">' + message + '</div></div>');
        setTimeout(function () { document.getElementById("th-wl-sucess-mgs").remove(); }, 4000);
      }
    }
    const errorMessage = (message) => {
      if (typeof $th_wishlistAdd_callback_errorMessage == 'function') {
        $th_wishlistAdd_callback_errorMessage(message);
      } else {
        document.querySelector('body').insertAdjacentHTML('beforeend', '<div id="th-wl-error-mgs">' + message + '</div></div>');
        setTimeout(function () { document.getElementById("th-wl-error-mgs").remove(); }, 4000);
      }
    }
    document.addEventListener('click', function (e) {
        let node = e.target;
        let inside = false;
        while (node) {
            if (node.classList.contains('th_wl_dropdown')) {
                inside = true;
                break;
            }
            node = node.parentElement;
        }
        if (!inside) {
            document.querySelectorAll('.th_wl_dropdown_content').forEach(function (element) {
                element.style.display = "none"
            })
        }
    });
    const buttonClickAddWishlist = () => {
        //add modal
        if (document.getElementById('createNewWishlist')) {
          var element = document.getElementById('createNewWishlist');
          element.remove();
          document.querySelectorAll('body')[0].insertAdjacentHTML('beforeend', createNewWishlist); 
          createNewListNameValueChange();
        }
        else {
          document.querySelectorAll('body')[0].insertAdjacentHTML('beforeend', createNewWishlist); 
          createNewListNameValueChange();
        }
        const thWlBtn = document.querySelectorAll('.th_wl_btn-primary');
        thWlBtn.forEach(function($this_button, idx) {
            if (idx === (thWlBtn.length - 1)) {
                const loading = '<span class="wl_btn_loading"><svg viewBox="0 0 100 100"><path d="M73,50c0-12.7-10.3-23-23-23S27,37.3,27,50 M30.9,50c0-10.5,8.5-19.1,19.1-19.1S69.1,39.5,69.1,50"><animateTransform attributeName="transform" attributeType="XML" type="rotate" dur="1s" from="0 50 50" to="360 50 50" repeatCount="indefinite" /></path></svg></span>'
                $this_button.addEventListener('click', function(event) {
                    $this_button.insertAdjacentHTML("beforeend", loading)
                    let product_id_add = $this_button.getAttribute('data-product_id');
                    let product_variant_id = $this_button.getAttribute('data-variant_id');
                    let wishlist_label = $this_button.closest('.th_wl_modal_content').querySelector('.th_wl_modal_body #wishlistlisttext').value;
                    onCreateNewList(product_id_add, wishlist_label, product_variant_id, $this_button)
                });
            }

        });
        document.querySelectorAll('.th_wl_dropbtn').forEach(function ($this_button) {
            $this_button.addEventListener('click', function (event) {
                if ((data.guest_wishlist === 1) || (data.guest_wishlist === 0 && wlcCustomer_id != "")) {
                    document.querySelectorAll('.th_wl_dropdown_content').forEach(function (element) {
                        element.style.display = "none"
                    })
                    let newWishlistDropdown = '';
                    (th_wishlist || []).forEach((x) => {
                        if (x.name) {
                            newWishlistDropdown += '<li><span class="th_wl_dropdown_option" data-wishlistid="' + x.id + '" >' + x.name + '</span><span class="th_wl_dropdown_option_delete_btn" data-wishlistid="' + x.id + '" data-wishlist_dropdown_text="' + data.wishlist_dropdown_text + '" onclick="onDeleteWishListList(this)">' + deleteIcon + '</span></li>';
                        }
                    });
                    newWishlistDropdown += '<li><span class="th_wl_dropdown_option">' + data.wishlist_dropdown_text + '</span></li>';
                    $this_button.closest('.th_prd_wl_btn, .th_wl_col_btn, .th_wl_btn').querySelector('.th_wl_dropdown_content').innerHTML = newWishlistDropdown;
                    addEventListner()
                    $this_button.closest('.th_prd_wl_btn, .th_wl_col_btn, .th_wl_btn').querySelector('.th_wl_dropdown_content').style.display = 'block';
                } else {
                    window.location.href = '/account/login';
                }
            });
        });
        document.querySelectorAll('.th_wl_modal_close_coman').forEach(function($this_button) {
            $this_button.addEventListener('click', function(event) {
                document.getElementById('createNewWishlist').style.display = 'none';
            });
        });
        const addEventListner = () => {
            document.querySelectorAll('.th_wl_dropdown_option').forEach(function ($this_button) {
                $this_button.addEventListener('click', function (event) {
                    event.preventDefault();
                    let product_id_add = $this_button.closest('.th_prd_wl_btn, .th_wl_col_btn, .th_wl_btn').getAttribute('data-product_id');
                    let product_variant_id = $this_button.closest('.th_prd_wl_btn, .th_wl_col_btn, .th_wl_btn').getAttribute('data-variant_id') || "";
                    let wishlistid = $this_button.closest('.th_wl_dropdown_option').getAttribute('data-wishlistid');
                    let index = (products || []).findIndex((x) => x.shopify_product_id == product_id_add);
                    let record = { ...products[index] };
                    let newRecord = { ...record, wishlistCount: record.wishlistCount + 1 };
                    products[index] = newRecord;
                    if (wishlistid) {
                        addProductToWishlist(product_id_add, wishlistid, newRecord, product_variant_id)
                    } else {
                        document.getElementById('createNewWishlist').style.display = 'flex';
                        document.querySelector('.th_wl_modal-dialog .th_wl_btn-primary').setAttribute("data-product_id", product_id_add);
                        document.querySelector('.th_wl_modal-dialog .th_wl_btn-primary').setAttribute("data-variant_id", product_variant_id);
                    }
                });
            });
        }
        addEventListner();
        document.querySelectorAll('.th_wl_button').forEach(function ($this_button) {
            $this_button.addEventListener('click', function (event) {
                event.preventDefault();
                if ($this_button.closest('.th_prd_wl_btn, .th_wl_col_btn, .th_wl_btn')) {
                  let product_id_add = $this_button.closest('.th_prd_wl_btn, .th_wl_col_btn, .th_wl_btn').getAttribute('data-product_id');
                  let product_variant_id = $this_button.closest('.th_prd_wl_btn, .th_wl_col_btn, .th_wl_btn').getAttribute('data-variant_id') || "";
                  const index = (products || []).findIndex((x) => x.shopify_product_id == product_id_add);
                  let record = { ...products[index] };
                  let newRecord = { ...record, wishlistCount: record.wishlistCount + 1 }
                  products[index] = newRecord;
                  const checkWishlist = () => {
                      if (th_wishlist && th_wishlist.length) {
                          addProductToWishlist(product_id_add, th_wishlist[0].id, newRecord, product_variant_id);
                      } else {
                          if (data.multiple_wishlist === 1) {
                              document.getElementById('createNewWishlist').style.display = 'flex';
                              document.querySelector('.th_wl_modal-dialog .th_wl_btn-primary').setAttribute("data-product_id", product_id_add);
                              document.querySelector('.th_wl_modal-dialog .th_wl_btn-primary').setAttribute("data-variant_id", product_variant_id);
                          } else {
                              onCreateNewList(product_id_add, data.default_wishlist_title, product_variant_id, "")
                          }
                      }
                  }
                  if ((data.guest_wishlist === 1) || (data.guest_wishlist === 0 && wlcCustomer_id != "")) {
                      checkWishlist()
                  } else {
                      window.location.href = '/account/login';
                  } 
                }
            });
        });
    }
    const buttonClickRemoveWishlist = () => {
        document.querySelectorAll('.th_wl_button_after').forEach(function ($this_button) {
            $this_button.addEventListener('click', async function (event) {
                let wlcIp = wlcGetCookie("wlcIp") || "";
                if ($this_button.closest('.th_prd_wl_btn, .th_wl_col_btn, .th_wl_btn')) {
                  let product_id_add = $this_button.closest('.th_prd_wl_btn, .th_wl_col_btn, .th_wl_btn').getAttribute('data-product_id');
                  let variant_id_add = $this_button.closest('.th_prd_wl_btn, .th_wl_col_btn, .th_wl_btn').getAttribute('data-variant_id') || "";
                  const index = (products || []).findIndex((x) => x.shopify_product_id == product_id_add);
                  let record = { ...products[index] };
                  let newRecord = { ...record, wishlistCount: record.wishlistCount > 0 ? record.wishlistCount - 1 : 0 }
                  products[index] = newRecord;
                  let data_json = JSON.stringify({ shop: wlcShop, product_id: product_id_add, variant_id: variant_id_add, customer_id: wlcCustomer_id, ip: wlcIp });
                  if(data.is_variant_wishlist == 1){
                      document.querySelectorAll('.th_prd_wl_btn[data-product_id="' + product_id_add + '"][data-variant_id="' + variant_id_add + '"], .th_wl_col_btn[data-product_id="' + product_id_add + '"][data-variant_id="' + variant_id_add + '"], .th_wl_btn[data-product_id="' + product_id_add + '"][data-variant_id="' + variant_id_add + '"]').forEach((this_all) => {
                          this_all.innerHTML = wishlistButton(this_all, newRecord);
                      })
                  } else {
                      document.querySelectorAll('.th_prd_wl_btn[data-product_id="' + product_id_add + '"], .th_wl_col_btn[data-product_id="' + product_id_add + '"], .th_wl_btn[data-product_id="' + product_id_add + '"]').forEach((this_all) => {
                          this_all.innerHTML = wishlistButton(this_all, newRecord);
                      })
                  }
                  const response = await fetch(wlcApiUrl + '/v1/remove', {
                      method: 'POST',
                      body: data_json,
                      headers: {
                          'Content-Type': 'application/json'
                      }
                  });
                  const myJson = await response.json();
                  if (myJson.status === 200) {
                      newTotalProduct = newTotalProduct === 0 ? 0 : newTotalProduct - 1;
                      localStorage.setItem('th_wlc_pro_count', newTotalProduct)
                      if (document.querySelector('.th_wlc_product_count')) {
                        if (newTotalProduct > 0) {
                          document.querySelector('.th_wlc_product_count').style.display = 'inherit';
                        } else {
                          if (document.querySelector('.th_wlc_product_count')) {
                            document.querySelector('.th_wlc_product_count').style.display = 'none';
                          }
                        }
                          document.querySelectorAll('.th_wlc_product_count').forEach(function (th_wlc_product_count, idx) {
                              th_wlc_product_count.innerHTML = '<span>' + newTotalProduct + '</span>';
                          });
                      }
                      if(data.is_variant_wishlist == 1){
                          document.querySelectorAll('.th_prd_wl_btn[data-product_id="' + product_id_add + '"][data-variant_id="' + variant_id_add + '"], .th_wl_col_btn[data-product_id="' + product_id_add + '"][data-variant_id="' + variant_id_add + '"], .th_wl_btn[data-product_id="' + product_id_add + '"][data-variant_id="' + variant_id_add + '"]').forEach((this_all) => {
                              this_all.innerHTML = wishlistButton(this_all, newRecord);
                          })
                      } else {
                          document.querySelectorAll('.th_prd_wl_btn[data-product_id="' + product_id_add + '"], .th_wl_col_btn[data-product_id="' + product_id_add + '"], .th_wl_btn[data-product_id="' + product_id_add + '"]').forEach((this_all) => {
                              this_all.innerHTML = wishlistButton(this_all, newRecord);
                          })
                      }
                      buttonClickAddWishlist();
                      if (typeof $th_wishlistRemove_callback_successMessage == 'function') {
                          $th_wishlistRemove_callback_successMessage();
                      } else {
                          sucessMessage(data.product_remove_wishlist)
                      }
                  } else {
                      if(data.is_variant_wishlist == 1){
                          document.querySelectorAll('.th_prd_wl_btn[data-product_id="' + product_id_add + '"][data-variant_id="' + variant_id_add + '"], .th_wl_col_btn[data-product_id="' + product_id_add + '"][data-variant_id="' + variant_id_add + '"], .th_wl_btn[data-product_id="' + product_id_add + '"][data-variant_id="' + variant_id_add + '"]').forEach((this_all) => {
                              this_all.innerHTML = wishlistButtonAfter(this_all, record);
                          })
                      } else {
                          document.querySelectorAll('.th_prd_wl_btn[data-product_id="' + product_id_add + '"], .th_wl_col_btn[data-product_id="' + product_id_add + '"], .th_wl_btn[data-product_id="' + product_id_add + '"]').forEach((this_all) => {
                              this_all.innerHTML = wishlistButtonAfter(this_all, record);
                          })
                      }
                      buttonClickAddWishlist();
                      if (typeof $th_wishlistRemove_callback_errorMessage == 'function') {
                          $th_wishlistRemove_callback_errorMessage();
                      } else {
                          errorMessage("Product is not remove to wishlist")
                      }
                  } 
                }
            });
        });
    }
    const addProductToWishlist = async (product_id_add, wishlist_id, record, product_variant_id) => {
        let wlcIp = wlcGetCookie("wlcIp") || "";
        let variant_id = product_variant_id
        if (__st.p === "product") {
            let urlParams = new URLSearchParams(window.location.search);
            let variant = urlParams.get('variant') || '';
            if (variant) {
                variant_id = variant
            } else if (product_variant_id) {
                variant_id = product_variant_id
            } else if (document.querySelector('[name="id"]')) {
                variant_id = document.querySelector('[name="id"]').value
            }
        }
        let data_json = JSON.stringify({ shop: wlcShop, product_id: product_id_add, customer_id: wlcCustomer_id, wishlist_id: wishlist_id, variant_id: variant_id, ip: wlcIp });
        if(data.is_variant_wishlist == 1){
            document.querySelectorAll('.th_prd_wl_btn[data-product_id="' + product_id_add + '"][data-variant_id="' + variant_id + '"], .th_wl_col_btn[data-product_id="' + product_id_add + '"][data-variant_id="' + variant_id + '"], .th_wl_btn[data-product_id="' + product_id_add + '"][data-variant_id="' + variant_id + '"]').forEach((this_all) => {
                this_all.innerHTML = wishlistButtonAfter(this_all, record);
            })
        } else {
            document.querySelectorAll('.th_prd_wl_btn[data-product_id="' + product_id_add + '"], .th_wl_col_btn[data-product_id="' + product_id_add + '"], .th_wl_btn[data-product_id="' + product_id_add + '"]').forEach((this_all) => {
                this_all.innerHTML = wishlistButtonAfter(this_all, record);
            })
        }
        const response = await fetch(wlcApiUrl + '/v1/add', {
            method: 'POST',
            body: data_json,
            headers: {
                'Content-Type': 'application/json'
            }
        });
        const myJson = await response.json();
        if (myJson.status === 302) {
            window.location.href = '/account/login';
        } else if (myJson.status === 200) {
            newTotalProduct = newTotalProduct + 1;
            localStorage.setItem('th_wlc_pro_count', newTotalProduct)
            if (document.querySelector('.th_wlc_product_count')) {
              if (newTotalProduct > 0) {
                document.querySelector('.th_wlc_product_count').style.display = 'inherit';
              } else {
                if (document.querySelector('.th_wlc_product_count')) {
                  document.querySelector('.th_wlc_product_count').style.display = 'none';
                }
              }
                document.querySelectorAll('.th_wlc_product_count').forEach(function (th_wlc_product_count, idx) {
                    th_wlc_product_count.innerHTML = '<span>' + newTotalProduct + '</span>';
                });
            }
            if (document.getElementById('createNewWishlist')) {
              document.getElementById('createNewWishlist').style.display = 'none';
            }
            if(data.is_variant_wishlist == 1){
                document.querySelectorAll('.th_prd_wl_btn[data-product_id="' + product_id_add + '"][data-variant_id="' + variant_id + '"], .th_wl_col_btn[data-product_id="' + product_id_add + '"][data-variant_id="' + variant_id + '"], .th_wl_btn[data-product_id="' + product_id_add + '"][data-variant_id="' + variant_id + '"]').forEach((this_all) => {
                    this_all.innerHTML = wishlistButtonAfter(this_all, record);
                })
            } else {
                document.querySelectorAll('.th_prd_wl_btn[data-product_id="' + product_id_add + '"], .th_wl_col_btn[data-product_id="' + product_id_add + '"], .th_wl_btn[data-product_id="' + product_id_add + '"]').forEach((this_all) => {
                    this_all.innerHTML = wishlistButtonAfter(this_all, record);
                })
            }

            buttonClickRemoveWishlist();
            sucessMessage(data.product_add_to_wishlist)
            if (typeof wishlistAddSucessProductCallback === "function") {
                wishlistAddSucessProductCallback({ product_id: product_id_add, variant_id: variant_id })
            }
        } else {
            if(data.is_variant_wishlist == 1){
                document.querySelectorAll('.th_prd_wl_btn[data-product_id="' + product_id_add + '"][data-variant_id="' + variant_id + '"], .th_wl_col_btn[data-product_id="' + product_id_add + '"][data-variant_id="' + variant_id + '"], .th_wl_btn[data-product_id="' + product_id_add + '"][data-variant_id="' + variant_id + '"]').forEach((this_all) => {
                    this_all.innerHTML = wishlistButtonAfter(this_all, record);
                })
            } else{
                document.querySelectorAll('.th_prd_wl_btn[data-product_id="' + product_id_add + '"], .th_wl_col_btn[data-product_id="' + product_id_add + '"], .th_wl_btn[data-product_id="' + product_id_add + '"]').forEach((this_all) => {
                    this_all.innerHTML = wishlistButtonAfter(this_all, record);
                })
            }
            buttonClickRemoveWishlist();
            errorMessage("Product is not added to wishlist")
        }
    }
    const onCreateNewList = async (product_id_add, wishlist_label, product_variant_id, $this_button) => {

        let wlcIp = wlcGetCookie("wlcIp") || "";
        let data_json = JSON.stringify({
            shop: wlcShop,
            name: wishlist_label,
            customer_id: wlcCustomer_id,
            ip: wlcIp
        });
        const response = await fetch(wlcApiUrl + '/v1/wishlist', {
            method: 'POST',
            body: data_json,
            headers: {
                'Content-Type': 'application/json'
            }
        });
        const myJson = await response.json();
        if (myJson.status === 200) {
            let index = (products || []).findIndex((x) => x.shopify_product_id == product_id_add);
            let record = {
                ...products[index]
            };
            let newRecord = {
                ...record,
                wishlistCount: record.wishlistCount + 1
            };
            products[index] = newRecord;
            let obj = {
                id: myJson.id,
                name: wishlist_label
            }
            th_wishlist.push(obj);
            if ($this_button) {
                $this_button.querySelector(".wl_btn_loading").remove();
                if (document.querySelector(".th_wl_form_control")) {
                    document.querySelector(".th_wl_form_control").value = ""
                }
            }
            addProductToWishlist(product_id_add, myJson.id, newRecord, product_variant_id)
        }
    }
    products.forEach((x, i) => {
        if (x.wishlisted === true) {
            if(data.is_variant_wishlist == 1 && x.shopify_variant_id){
                document.querySelectorAll('.th_prd_wl_btn[data-product_id="' + x.shopify_product_id + '"][data-variant_id="' + x.shopify_variant_id + '"], .th_wl_col_btn[data-product_id="' + x.shopify_product_id + '"][data-variant_id="' + x.shopify_variant_id + '"], .th_wl_btn[data-product_id="' + x.shopify_product_id + '"][data-variant_id="' + x.shopify_variant_id + '"]').forEach(function (th_loop_this) {
                    th_loop_this.innerHTML = wishlistButtonAfter(th_loop_this, x);
                });
            } else {
                document.querySelectorAll('.th_prd_wl_btn[data-product_id="' + x.shopify_product_id  + '"], .th_wl_col_btn[data-product_id="' + x.shopify_product_id  + '"], .th_wl_btn[data-product_id="' + x.shopify_product_id + '"]').forEach(function (th_loop_this) {
                    th_loop_this.innerHTML = wishlistButtonAfter(th_loop_this, x);
                });
            }
        } else {
            if(data.is_variant_wishlist == 1 && x.shopify_variant_id){
                document.querySelectorAll('.th_prd_wl_btn[data-product_id="' + x.shopify_product_id + '"][data-variant_id="' + x.shopify_variant_id + '"], .th_wl_col_btn[data-product_id="' + x.shopify_product_id + '"][data-variant_id="' + x.shopify_variant_id + '"], .th_wl_btn[data-product_id="' + x.shopify_product_id + '"][data-variant_id="' + x.shopify_variant_id + '"]').forEach(function (th_loop_this) {
                    th_loop_this.innerHTML = wishlistButton(th_loop_this, x);
                });
            } else{
                document.querySelectorAll('.th_prd_wl_btn[data-product_id="' + x.shopify_product_id  + '"], .th_wl_col_btn[data-product_id="' + x.shopify_product_id  + '"], .th_wl_btn[data-product_id="' + x.shopify_product_id + '"]').forEach(function (th_loop_this) {
                    th_loop_this.innerHTML = wishlistButton(th_loop_this, x);
                });
            }
        }
        if (i === (products.length - 1)) {
            buttonClickAddWishlist();
            buttonClickRemoveWishlist();
        }
    });
}
/*Wishlist call when variant is changed callback function start*/
function wlProductVariantChange (productId, variantId) {
    if(productId && variantId){
        let wlcProductVariant = {[variantId]: productId};
        document.querySelectorAll('.th_prd_wl_btn[data-product_id="' + productId + '"], .th_wl_col_btn[data-product_id="' + productId + '"], .th_wl_btn[data-product_id="' + productId + '"]').forEach(function (th_loop_this) {
            th_loop_this.setAttribute('data-variant_id', variantId);
        });
        getWishlistSettings(wlcProductVariant, "1")
    }
}
/*Wishlist call when variant is changed callback function end*/
const getBackInStockSettings = async (product) => {
    let wlcIp = wlcGetCookie("wlcIp") || "";
    let data_json = JSON.stringify({ shop: wlcShop, product_ids: product });
    const response = await fetch(wlcApiUrl + '/v1/products', {
        method: 'POST',
        body: data_json,
        headers: {
            'Content-Type': 'application/json'
        }
    });
    const myJson = await response.json();
    if (myJson.status === 200) {
        backInStockSettings = myJson?.data?.bis;
        wlBackInStockProduct = myJson?.data?.products;
        addBackInStockButton(myJson?.data?.bis, myJson?.data?.products);
    }
}
function addBackInStockButton(backInStockSettings, wlBackInStockProduct){
    let wcBtnText = "";
    let wcBtnTextColor = "";
    let wcBtnIsIcon = "";
    let wcBtnIsActive = "";
    let wcBtnIconColor = "";
    let wcBtnBorderSize = "";
    let wcBtnBorderRadius = "";
    let wcBtnBorderColor = "";
    let wcBtnBgColor = "";
    let wcBtnPTB = "";
    let wcBtnPLR = "";
    if(wlcPage === 'product'){
        wcBtnText = backInStockSettings.product_page_widget.text;
        wcBtnTextColor = backInStockSettings.product_page_widget.text_color;
        wcBtnIsIcon = backInStockSettings.product_page_widget.is_icon;
        wcBtnIsActive = backInStockSettings.product_page_widget.is_active;
        wcBtnIconColor = backInStockSettings.product_page_widget.icon_color;
        wcBtnBorderSize = backInStockSettings.product_page_widget.border_size;
        wcBtnBorderRadius = backInStockSettings.product_page_widget.border_radius;
        wcBtnBorderColor = backInStockSettings.product_page_widget.border_color;
        wcBtnBgColor = backInStockSettings.product_page_widget.bg_color;
        wcBtnPTB = backInStockSettings.product_page_widget.button_top_bottom_padding;
        wcBtnPLR = backInStockSettings.product_page_widget.button_left_right_padding;
    } else if(wlcPage === 'collection'){
        wcBtnText = backInStockSettings.collection_page_widget.text;
        wcBtnTextColor = backInStockSettings.collection_page_widget.text_color;
        wcBtnIsIcon = backInStockSettings.collection_page_widget.is_icon;
        wcBtnIsActive = backInStockSettings.collection_page_widget.is_active;
        wcBtnIconColor = backInStockSettings.collection_page_widget.icon_color;
        wcBtnBorderSize = backInStockSettings.collection_page_widget.border_size;
        wcBtnBorderRadius = backInStockSettings.collection_page_widget.border_radius;
        wcBtnBorderColor = backInStockSettings.collection_page_widget.border_color;
        wcBtnBgColor = backInStockSettings.collection_page_widget.bg_color;
        wcBtnPTB = backInStockSettings.collection_page_widget.button_top_bottom_padding;
        wcBtnPLR = backInStockSettings.collection_page_widget.button_left_right_padding;
    } else if(wlcPage === 'home'){
        wcBtnText = backInStockSettings.home_page_widget.text;
        wcBtnTextColor = backInStockSettings.home_page_widget.text_color;
        wcBtnIsIcon = backInStockSettings.home_page_widget.is_icon;
        wcBtnIsActive = backInStockSettings.home_page_widget.is_active;
        wcBtnIconColor = backInStockSettings.home_page_widget.icon_color;
        wcBtnBorderSize = backInStockSettings.home_page_widget.border_size;
        wcBtnBorderRadius = backInStockSettings.home_page_widget.border_radius;
        wcBtnBorderColor = backInStockSettings.home_page_widget.border_color;
        wcBtnBgColor = backInStockSettings.home_page_widget.bg_color;
        wcBtnPTB = backInStockSettings.home_page_widget.button_top_bottom_padding;
        wcBtnPLR = backInStockSettings.home_page_widget.button_left_right_padding;
    }
    if(wcBtnIsActive == 1){
        if (document.querySelectorAll('#wcBackInStockCss').length === 0) {
            let cssData = '<style id="wcBackInStockCss">'
            cssData += `.wc_wl_bis_btn{position: relative; z-index: 99999;}`;
            cssData += `.wc_wl_bis_btn button{padding: ${wcBtnPTB}px ${wcBtnPLR}px; width: 100%; font-size: 14px; background-color: ${wcBtnBgColor}; border: ${wcBtnBorderSize}px solid ${wcBtnBorderColor}; color: ${wcBtnTextColor}; border-radius: ${wcBtnBorderRadius}px; cursor: pointer; display: flex; align-items: center; justify-content: center; }`;
            cssData += `.wc_wl_bis_btn button .wcBsiNotifyIcon{margin-right: 5px;}`;
            cssData += `.wcBsiModal{display: flex; flex-wrap: wrap; align-items: center; justify-content: center; overflow-x: hidden; overflow-y: auto; opacity: 1; z-index: 99999; position: fixed; top: 0;right: 0;bottom: 0; left: 0; outline: 0; transition: opacity .15s linear; background-color: #000000b3;}`;
            cssData += `.wcBsiModalDialog{animation: fadeIn 200ms ease-in both; transition: -webkit-transform .3s ease-out;transition: transform .3s ease-out; transition: transform .3s ease-out,-webkit-transform .3s ease-out; max-width: 360px; display: -webkit-box; display: flex; align-items: center; position: relative; pointer-events: none; flex: 0 0 360px;}`;
            cssData += `.wcBsiModalContent{position: relative; display: -webkit-box; display: -ms-flexbox; display: flex; -webkit-box-orient: vertical; -webkit-box-direction: normal; -ms-flex-direction: column; flex-direction: column; width: 100%; pointer-events: auto; background-color: #fff; background-clip: padding-box; border: 1px solid rgba(0,0,0,.2); border-radius: 10px; outline: 0;}`;
            cssData += `.wcBsiModalHeader{display: -webkit-box; display: -ms-flexbox; display: flex; -webkit-box-align: start; -ms-flex-align: start; align-items: flex-start; -webkit-box-pack: justify; -ms-flex-pack: justify; justify-content: space-between; padding: 1rem; border-bottom: 1px solid #e9ecef; border-top-left-radius: .3rem; border-top-right-radius: .3rem; align-items: center;}`;
            cssData += `.wcBsiHeaderTitle{margin: 0; line-height: 1.5; font-size: 20px}`;
            cssData += `.wcBsiHeaderClose{padding: 16px; margin: -1rem -1rem -1rem auto; background-color: transparent; border: 0; float: right; font-size: 18px; font-weight: 700; line-height: 1; color: #000; text-shadow: 0 1px 0 #fff; text-transform: none;cursor: pointer;}`;
            cssData += `.wcBsiHeaderClose svg{width: 16px; height: 16px; }`;
            cssData += `.wcBsiModalBody{position: relative; -webkit-box-flex: 1; -ms-flex: 1 1 auto; flex: 1 1 auto; padding: 16px 16px 20px;}`;
            cssData += `.wcBsiFormGroup{margin-bottom: 15px;}`;
            cssData += `.wcBsiFormGroup:last-child{margin-bottom: 0;}`;
            cssData += `.wcBsiFormLabel{padding-top: 5px;padding-bottom: 5px ;margin-bottom: 0;font-size: inherit; line-height: 1.5; display: inline-block}`;
            cssData += `.wcBsiFormControl{display: block;width: 100%;padding: 6px 12px;font-size: 16px;line-height: 1.5;color: #495057;background-color: #fff;background-clip: padding-box;border: 1px solid #ced4da;border-radius: 6px ;transition: border-color .15s ease-in-out,box-shadow .15s ease-in-out;}`;
            cssData += `.wcBsiFormControl:focus-visible{outline: none;outline-offset: inherit; box-shadow: none;} `;
            cssData += `select.wcBsiFormControl{padding: 6px 36px 6px 12px;font-size: 16px;line-height: 1.5;background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3e%3cpath fill='none' stroke='%23343a40' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='M2 5l6 6 6-6'/%3e%3c/svg%3e");-webkit-appearance: none;-moz-appearance: none;appearance: none;background-repeat: no-repeat;background-position: right 0.75rem center;background-size: 16px 12px;}`;
            cssData += `.wcBsiFormGroup small{color: #f00; visibility: hidden;opacity: 0;}`;
            cssData += `.wcBsiFormGroup.error small {visibility: visible;opacity: 1;}`
            cssData += `.wcBsiFormBtnSubmit{padding: ${backInStockSettings.subscription_form.button_top_bottom_padding}px ${backInStockSettings.subscription_form.button_left_right_padding}px; width: 100%; font-size: 14px; background-color: ${backInStockSettings.subscription_form.background_color}; border: ${backInStockSettings.subscription_form.border_size}px solid ${backInStockSettings.subscription_form.border_color}; color: ${backInStockSettings.subscription_form.text_color}; border-radius: ${backInStockSettings.subscription_form.border_radius}px; cursor: pointer }`;
            cssData += `@keyframes fadeIn {from {opacity: 0; transform: translate3d(0, -20%, 0); } to {opacity: 1; transform: translate3d(0, 0, 0);}}`
            cssData += `#wcBsiMessage{font-size: 17px;min-width: 250px;padding: 10px 12px;text-align: left;border-radius: 2px;position: fixed;right: 0;top: 0;z-index: 99999;-webkit-animation-name: fadeInRightBsiMessage;animation-name: fadeInRightBsiMessage;-webkit-animation-delay: 50ms;-moz-animation-delay: 50ms;animation-delay: 50ms;-webkit-animation-duration: 300ms;animation-duration: 300ms;-webkit-animation-fill-mode: both;animation-fill-mode: both;}`;
            cssData += `#wcBsiMessage {color: ${backInStockSettings.subscription_message.text_color};background-color: ${backInStockSettings.subscription_message.background_color};}`;
            cssData += `@-webkit-keyframes fadeInRightBsiMessage {from { opacity: 0; -webkit-transform: translate3d(100%, 0, 0); transform: translate3d(100%, 0, 0);}to { opacity: 1;  -webkit-transform: none; transform: none;}}`;
            cssData += `@keyframes fadeInRightBsiMessage {from { opacity: 0; -webkit-transform: translate3d(100%, 0, 0); transform: translate3d(100%, 0, 0);  }to { opacity: 1;  -webkit-transform: none;  transform: none;  }}`;
            cssData += '</style>';
            document.getElementsByTagName('head')[0].insertAdjacentHTML('beforeend', cssData);
        }
        if(wlBackInStockProduct){
            document.querySelectorAll(".wc_wl_bis_btn").forEach((x, i) => {
                const productId = x.getAttribute("data-product_id");
                const variantId = x.getAttribute("data-variant_id");
                const findVariant = (wlBackInStockProduct || []).find((v) => v.variant_id == variantId);
                const notifyIcon = '<svg width="20" height="20" viewBox="0 0 20 20" fill="none" ><path d="M10.0003 0C10.5525 0 11.0003 0.447716 11.0003 1V3L10.9998 3.0317L10.9988 3.05341L10.9969 3.0824C13.8362 3.55709 16.0003 6.02583 16.0003 9C16.0003 12.0933 16.6253 13.312 17.5989 15.2103L17.6336 15.2781C17.8033 15.6088 17.563 16 17.1912 16H2.80935C2.43753 16 2.19729 15.6088 2.36697 15.2781L2.40164 15.2103C3.37527 13.312 4.00027 12.0933 4.00027 9C4.00027 6.02583 6.16434 3.55709 9.00369 3.0824L9.00149 3.04284C9.00076 3.02863 9.00027 3.01435 9.00027 3V1C9.00027 0.447716 9.44803 0 10.0003 0Z" fill="'+wcBtnIconColor+'"></path><path d="M12.0003 18C12.0003 19.1046 11.1048 20 10.0003 20C8.89578 20 8.00027 19.1046 8.00027 18H12.0003Z" fill="'+wcBtnIconColor+'"></path></svg>'
                if(findVariant?.inventoryQuantity <= 0 && findVariant?.inventoryManagement == 'SHOPIFY' && findVariant?.inventoryPolicy == 'DENY'){
                    let wcBackInStockButton = "";
                    if(wcBtnIsIcon == "1"){
                        wcBackInStockButton += '<button type="button" data-product_id="'+ productId +'" data-variant_id="'+variantId+'">';
                        wcBackInStockButton += '<span class="wcBsiNotifyIcon">'+notifyIcon+'</span>';
                        wcBackInStockButton += '<span class="wcBsiNotifyText">'+wcBtnText+'</span>';
                        wcBackInStockButton += '</button>';
                    } else {
                        wcBackInStockButton += '<button type="button" data-product_id="'+ productId +'" data-variant_id="'+variantId+'"><span class="wcBsiNotifyText">'+wcBtnText+'</span></button>'
                    }

                    x.innerHTML = wcBackInStockButton;
                    x.addEventListener('click', function (event) {
                        onClickBackInStockButton(productId, variantId)
                    })
                } else  {
                    x.innerHTML = "";
                }
            })
        }
    };
    const showError = (input, msg) => {
        const formControl = input.parentElement;
        const small = formControl.querySelector("small");
        formControl.classList.add("error");
        small.textContent = msg;
    };
    const showSuccess = (input) => {
        const formControl = input.parentElement;
        formControl.classList.remove("error");
        formControl.querySelector("small").innerHTML = "";
    };
    const wcBsiCheckRequired = (inputArr) => {
        inputArr.forEach((input) => {
            input.addEventListener("blur", function (e) {
                if (input.name === "wcBsiEmail") {
                    const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                    if (re.test(input.value)) {
                        showSuccess(input);
                    } else {
                        showError(input, backInStockSettings.subscription_form.email_validation_message);
                    }
                }
            });
        })
    }
    const sucessMessage = (message) => {
        document.querySelector('body').insertAdjacentHTML('beforeend', '<div id="wcBsiMessage">' + message + '</div></div>');
        setTimeout(function () { document.getElementById("wcBsiMessage").remove(); }, 4000);
    }
    const errorMessage = (message) => {
        document.querySelector('body').insertAdjacentHTML('beforeend', '<div id="wcBsiMessage">' + message + '</div></div>');
        setTimeout(function () { document.getElementById("wcBsiMessage").remove(); }, 4000);
    }
    const onSubmitBackInStock = async (productId, variantId) => {
        let wcBsiFormInput = [];
        document.querySelectorAll(".wcBsiFormGroup").forEach((thisInput) => {
            let name = thisInput;
            wcBsiFormInput.push(name)
        });
        wcBsiCheckRequired(wcBsiFormInput)
        if (document.querySelectorAll(".wcBsiFormGroup.error").length) {
            return true;
        } else {
            const variant_id = document.querySelector('#wcBsiVariant').value;
            const email = document.querySelector('#wcBsiEmail').value;
            const paylaod = {
                shop: wlcShop,
                product_id: productId,
                variant_id: variant_id || variantId,
                email: email
            }
            await fetch(`${wlcApiUrl}/v1/bis`, {
                method: 'POST',
                body: JSON.stringify(paylaod),
                cache: 'no-cache',
                headers: {
                    'Content-Type': 'application/json'
                },
            }).then(response => response.json()).then(async wcBsiResponse => {
                if(wcBsiResponse.status === 200){
                    document.body.style.overflow = 'auto';
                    document.querySelector(".wcBsiModal").remove();
                    sucessMessage(backInStockSettings.subscription_message.success_message)

                } else if(wcBsiResponse.status === 400){
                    document.body.style.overflow = 'auto';
                    document.querySelector(".wcBsiModal").remove();
                    errorMessage(backInStockSettings.subscription_message.already_subscribed_message)
                }
            }).catch((error) => {
                console.log(error);
            })
        }
    }
    const emailErrorChecker = () => {
      document.querySelector('#wcBsiEmail').addEventListener('keyup', function(event){
        var resultedValue = document.querySelector('#wcBsiEmail').value;
        var emailField = document.querySelector('#wcBsiEmail');
        var reg = /^(?:[\w\!\#\$\%\&\'\*\+\-\/\=\?\^\`\{\|\}\~]+\.)*[\w\!\#\$\%\&\'\*\+\-\/\=\?\^\`\{\|\}\~]+@(?:(?:(?:[a-zA-Z0-9](?:[a-zA-Z0-9\-](?!\.)){0,61}[a-zA-Z0-9]?\.)+[a-zA-Z0-9](?:[a-zA-Z0-9\-](?!$)){0,61}[a-zA-Z0-9]?)|(?:\[(?:(?:[01]?\d{1,2}|2[0-4]\d|25[0-5])\.){3}(?:[01]?\d{1,2}|2[0-4]\d|25[0-5])\]))$/
        if (reg.test(emailField.value) == false) { 
          document.querySelector('.wcBsiFormBtnSubmit').setAttribute('disabled', 'disabled');
        }
        else {
          document.querySelector('.wcBsiFormBtnSubmit').removeAttribute('disabled', 'disabled');
        }
      });
    }
    const onClickBackInStockButton = (productId, variantId) => {
        // if(document.querySelector(".wcBsiModal")){
        //     document.querySelector(".wcBsiModal").remove()
        // }
        let wcBisModal = "";
        const newProductToBeBackInStock = [];
        for (var k=0; k < wlBackInStockProduct.length; k++) {
          if (parseInt(wlBackInStockProduct[k]['product_id']) == parseInt(productId)) {
            newProductToBeBackInStock.push(wlBackInStockProduct[k]); 
          }
        }
        wcBisModal += '<div class="wcBsiModal">';
        wcBisModal += '<div class="wcBsiModalDialog">';
        wcBisModal += '<div class="wcBsiModalContent">';
        wcBisModal += '<div class="wcBsiModalHeader">';
        wcBisModal += '<h5 class="wcBsiHeaderTitle">'+ backInStockSettings.subscription_form.title +'</h5>';
        wcBisModal += '<button class="wcBsiHeaderClose">'
        wcBisModal += '<svg viewBox="0 0 20 20" ><path d="M11.414 10l6.293-6.293a1 1 0 10-1.414-1.414L10 8.586 3.707 2.293a1 1 0 00-1.414 1.414L8.586 10l-6.293 6.293a1 1 0 101.414 1.414L10 11.414l6.293 6.293A.998.998 0 0018 17a.999.999 0 00-.293-.707L11.414 10z" fill="#5C5F62"/></svg>';
        wcBisModal += '</button>';
        wcBisModal += '</div>';
        wcBisModal += '<div class="wcBsiModalBody">';
        wcBisModal += '<div class="wcBsiFormGroup">';
        wcBisModal += '<label class="wcBsiFormLabel">'+backInStockSettings.subscription_form.email_lable +'</label>';
        wcBisModal +='<input type="text" class="wcBsiFormControl" name="wcBsiEmail" id="wcBsiEmail" placeholder="'+backInStockSettings.subscription_form.email_placeholder+'">';
        wcBisModal +='<small></small>';
        wcBisModal += '</div>';
        if (newProductToBeBackInStock.length == 1 && newProductToBeBackInStock[0].title == "Default Title") {
          wcBisModal += '<input type="hidden" class="wcBsiFormControl" value="'+variantId+'" name="wcBsiVariant" id="wcBsiVariant">';
        }
        else {
          wcBisModal += '<div class="wcBsiFormGroup">';
          wcBisModal += '<select class="wcBsiFormControl" value="'+variantId+'" name="wcBsiVariant" id="wcBsiVariant">';
          newProductToBeBackInStock.filter((f) => f?.inventoryQuantity <= 0 && f?.inventoryManagement == 'SHOPIFY' && f?.inventoryPolicy == 'DENY').forEach((x) => {
              const seletedV = variantId === x.variant_id ? 'selected' : '';
              wcBisModal +='<option value="'+x.variant_id+'" '+seletedV+'>'+x.title+'</option>';
          });
          wcBisModal +='</select>';
          wcBisModal += '</div>'; 
        }
        wcBisModal +='<div class="wcBsiFormGroup">';
        wcBisModal +='<button class="wcBsiFormBtnSubmit" disabled="disabled">'+backInStockSettings.subscription_form.submit_button_text+'</button>';
        wcBisModal += '</div>';
        wcBisModal += '</div>';
        wcBisModal += '</div>';
        wcBisModal += '</div>';
        wcBisModal += '</div>';
        document.body.style.overflow = 'hidden';
        document.querySelector("body").insertAdjacentHTML('beforeend', wcBisModal);
        let wcBsiFormInput = [];
        document.querySelectorAll(".wcBsiFormControl").forEach((thisInput) => {
            let name = thisInput;
            wcBsiFormInput.push(name)
        });
        wcBsiCheckRequired(wcBsiFormInput)

        document.querySelector(".wcBsiFormBtnSubmit").addEventListener('click' , () => {
            onSubmitBackInStock(productId)
        })

        document.querySelectorAll(".wcBsiHeaderClose").forEach((x) => {
            x.addEventListener('click' , () => {
                document.body.style.overflow = 'auto';
                document.querySelector(".wcBsiModal").remove();
            })
        });
        emailErrorChecker();
    }
};
/*Back in stock call when variant is changed callback function start*/
const wlBackInStockProductVariantChange = (productId, variantId) => {
    if(productId && variantId){
        document.querySelectorAll('.wc_wl_bis_btn[data-product_id="' + productId + '"]').forEach(function (th_loop_this) {
            th_loop_this.setAttribute('data-variant_id', variantId);
        });
        addBackInStockButton(backInStockSettings, wlBackInStockProduct)

    }
}
/*Back in stock call when variant is changed callback function end*/
const pageloadWishlistgetEvent = () => {
    let wlcProd = [];
    let wlcProductVariant = {};
    let wlcBackInStockProduct = [];
    document.querySelectorAll('.th_prd_wl_btn:empty, .th_wl_col_btn:empty, .th_wl_btn:empty').forEach(function (val, idx) {
        let pId = val.getAttribute('data-product_id')
        let vId = val.getAttribute('data-variant_id');
        if (vId) {
            wlcProductVariant = {...wlcProductVariant, [vId] : pId}
        } else if(pId){
            wlcProd.push(pId);
        }
        if (idx === (document.querySelectorAll('.th_prd_wl_btn, .th_wl_col_btn, .th_wl_btn').length - 1)) {
            wlcProd = (product_ids || []).filter((x) => x);
        }
    });
    if(Object.keys(wlcProductVariant).length > 0 && is_Wishlist_load){
        getWishlistSettings(wlcProductVariant, "1");
    } else if (wlcProd.length > 0 && is_Wishlist_load) {
        getWishlistSettings(wlcProd, "2");
    }

    document.querySelectorAll('.wc_wl_bis_btn:empty').forEach(function (val, idx) {
        let pId = val.getAttribute('data-product_id');
        wlcBackInStockProduct.push(pId);
    });
    if(wlcBackInStockProduct.length > 0){
        getBackInStockSettings(wlcBackInStockProduct)
    }
}

window.addEventListener('load', (event) => {
    let totalCount = 0;
    totalCount = localStorage.getItem('th_wlc_pro_count') || 0;
    if (totalCount) {
        if (document.querySelector('.th_wlc_product_count')) {
          if (totalCount > 0) {
            document.querySelector('.th_wlc_product_count').style.display = 'inherit';
          } else {
            if (document.querySelector('.th_wlc_product_count')) {
              document.querySelector('.th_wlc_product_count').style.display = 'none';
            }
          }
            document.querySelectorAll('.th_wlc_product_count').forEach(function (th_wlc_product_count, idx) {
                th_wlc_product_count.innerHTML = '<span>' + totalCount + '</span>';
            });
        }
    }

    if(!localStorage.getItem('th_wlc_icon')){
        getWishlistSettings([], "");
    } else {
        if(document.querySelector(".th_wlc_position_relative")) {
            document.querySelectorAll('.th_wlc_position_relative').forEach(function (th_wlc_icon, idx) {
              if (th_wlc_icon.querySelector("svg")) {
               th_wlc_icon.querySelector("svg").remove(); 
              }
                let newWlIcon = "";
                newWlIcon += th_wlc_icon.innerHTML;
                newWlIcon += localStorage.getItem('th_wlc_icon') ? localStorage.getItem('th_wlc_icon') : '<svg width="26" height="23" viewBox="0 0 26 23" fill="none"><path d="M24.8759 3.27339C24.1475 2.06525 23.0806 1.12141 21.8207 0.57048C20.3932 -0.0562504 18.7897 -0.169062 17.1839 0.245058C15.7124 0.624602 14.279 1.4478 13 2.64198C11.7209 1.44769 10.2874 0.624442 8.8156 0.244952C7.20974 -0.169327 5.60622 -0.0564097 4.17865 0.570745C2.91872 1.12185 1.8519 2.06588 1.12359 3.27418C0.360858 4.53529 -0.0271625 6.06892 0.00147825 7.70909C0.128635 15.0007 10.5135 21.6311 12.594 22.8863C12.7175 22.9608 12.8575 23 13 23C13.1425 23 13.2825 22.9608 13.406 22.8863C15.4867 21.6309 25.8725 14.9993 25.9986 7.70782C26.0269 6.06775 25.6387 4.53428 24.8759 3.27339V3.27339ZM24.3739 7.67728C24.3332 10.0348 22.8306 12.7835 20.0288 15.6259C17.4342 18.258 14.4828 20.242 13 21.1651C11.5172 20.2422 8.56627 18.2584 5.97185 15.6262C3.16993 12.784 1.66731 10.0356 1.62618 7.67808C1.58129 5.10386 2.77074 3.03273 4.80794 2.13773C5.4756 1.84606 6.19237 1.69728 6.91592 1.70019C8.78442 1.70019 10.7609 2.64623 12.4206 4.41138C12.4962 4.49179 12.5864 4.55566 12.6859 4.59926C12.7853 4.64285 12.8921 4.6653 12.9999 4.6653C13.1078 4.6653 13.2145 4.64285 13.314 4.59926C13.4134 4.55566 13.5036 4.49179 13.5792 4.41138C15.885 1.95916 18.8021 1.08796 21.1913 2.13757C23.2287 3.03225 24.4183 5.10307 24.3739 7.67712V7.67728Z" fill="black"></path></svg>';
                th_wlc_icon.innerHTML = newWlIcon
            });
        }
    }
    pageloadWishlistgetEvent();
});
/* To Refresh the wishlist Items */
const $th_refreshWishlistItems = () => {
    let wlcProd = [];
    let wlcProductVariant = {};
    document.querySelectorAll('.th_prd_wl_btn:empty, .th_wl_col_btn:empty, .th_wl_btn:empty').forEach(function (val, idx) {
        let pId = val.getAttribute('data-product_id');
        let vId = val.getAttribute('data-variant_id');
        if (vId) {
            wlcProductVariant = {...wlcProductVariant, [vId] : pId}
        } else if(pId) {
            wlcProd.push(pId);
        }
    });
    if(Object.keys(wlcProductVariant).length > 0){
        getWishlistSettings(wlcProductVariant, "1");
    } else if (wlcProd.length > 0) {
        product_ids = wlcProd;
        getWishlistSettings(wlcProd, "2");
    }
}
const $th_refreshBackInStockItems = () => {
  let wlcBackInStockProduct = [];
  document.querySelectorAll('.wc_wl_bis_btn:empty').forEach(function (val, idx) {
    let pId = val.getAttribute('data-product_id');
    wlcBackInStockProduct.push(pId);
  });
  if(wlcBackInStockProduct.length > 0){
    getBackInStockSettings(wlcBackInStockProduct)
  }
}
window.addEventListener("load", (event) => {
  $th_refreshWishlistItems();
});
/* To Refresh the wishlist Items */
/* When Variant Changes on Product page function */
window.wcruntheFunction = true;
const onChangeVariantOptions = () => {
     document.querySelectorAll('form[action="/cart/add"]').forEach((self) => {
        self.addEventListener('change', function() {
          if (wcruntheFunction) {
            setTimeout(function(){
              var getShopifyVariantID = ShopifyAnalytics.meta.selectedVariantId;
              var getShopifyProductID = ShopifyAnalytics.meta.product.id.toString();
              if (getShopifyVariantID) {
                let wlcProductVariant = {
                    [getShopifyVariantID]: getShopifyProductID
                };
                if (document.querySelectorAll('.th_prd_wl_btn[data-product_id], .th_wl_col_btn[data-product_id], .th_wl_btn[data-product_id]')) {
                 document.querySelectorAll('.th_prd_wl_btn[data-product_id="' + getShopifyProductID + '"], .th_wl_col_btn[data-product_id="' + getShopifyProductID + '"], .th_wl_btn[data-product_id="' + getShopifyProductID + '"]').forEach(function(th_loop_this) {
                      var currentID = th_loop_this.getAttribute('data-variant_id');
                      if (getShopifyVariantID != currentID) {
                          th_loop_this.setAttribute('data-variant_id', getShopifyVariantID);
                          getWishlistSettings(wlcProductVariant, "1");
                      }
                  }); 
                }
                if (document.querySelectorAll('.wc_wl_bis_btn[data-product_id]')) {
                  document.querySelectorAll('.wc_wl_bis_btn[data-product_id="' + getShopifyProductID + '"]').forEach(function(th_loop_this) {
                      var currentID = th_loop_this.getAttribute('data-variant_id');
                      if (getShopifyVariantID != currentID) {
                          th_loop_this.setAttribute('data-variant_id', getShopifyVariantID);
                          addBackInStockButton(backInStockSettings, wlBackInStockProduct)
                      }
                  });
                } 
              }
            }, 200);
          }
        });
    });
}
onChangeVariantOptions();
/* When Variant Changes on Product page function */
// /*To Share JSON to the customers who want to make dynamic wishlist design End */
// window.$thGetWishlistJSON = async () => {
//   let wlcIp = wlcGetCookie("wlcIp") || "";
//   const urlParams = new URLSearchParams(window.location.search);
//   const wlid = urlParams.get("wlid") || "";
//   const payload = JSON.stringify({
//     shop: wlcShop,
//     customer_id: wlcCustomer_id,
//     ip: wlcIp,
//     wishlist_share: wlid,
//   });
//   const $wc_GetWishlist_response = await fetch(wlcApiUrl+"/v1/get-setting", {
//     method: "POST",
//     body: payload,
//     headers: {
//       "Content-Type": "application/json",
//     },
//   });
//   const myJson = await $wc_GetWishlist_response.json();
//   if (typeof getWishlistItemsDetails == 'function') {
//     getWishlistItemsDetails(myJson);
//   }
//   //return $wc_GetWishlist_response;
// }
// $thGetWishlistJSON();
// /*To Share JSON to the customers who want to make dynamic wishlist design End*/